// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"58":"a64ea83d","133":"36e6813d","997":"cd9662ec"}[chunkId] + ".css";
};